import React, { FC } from 'react';
import { IconButton, styled, useTheme } from '@qbe/ads-core';
import { FormCard, DetailedList, DetailedListProps } from '@qbe/ads-blocks-forms';
import { useContentContext } from '@qbe/dfc-content';
import EditIcon from '@mui/icons-material/Edit';

import { IncomeData } from 'contexts/FormProvider';
import FormSpacer from 'components/FormSpacer/FormSpacer';

import { useTrackSummary } from 'hooks/useAnalytics';
import { useContentComplaintPartners } from 'utils/content';
import { List } from '@qbe/ads-blocks-forms/src/DetailedList/DetailedList.type';

type Props = {
  field: IncomeData;
  onEdit: () => void;
};

const StyledDetailedList = styled(DetailedList)`
  .ListGroup__list-wrapper > .ListGroup__list-label--multiple span {
    font-weight: 100 !important;
    font-size: 1rem;
  }

  .ListGroup__list > p {
    font-weight: 700;
    font-size: 1rem;
  }
`;

const IncomePreview: FC<Props> = ({ field, onEdit }) => {
  const { palette } = useTheme();

  const { getTextContent } = useContentComplaintPartners({
    context: useContentContext(),
  });

  const entry = (contentKey: string, value: string): List => ({
    id: `${field.id}-${contentKey}`,
    name: `${field.id}-${contentKey}`,
    label: getTextContent(`Income.summary.${contentKey}`),
    value,
  });

  const details: List[] = [
    { key: 'incomeType', value: field.incomeType },
    { key: 'incomeAmount', value: `$${field.incomeAmount}` || '' },
    { key: 'incomeDescription', value: field.incomeDescription },
  ].map((item) => entry(item.key, item.value as string));

  useTrackSummary('incomeSummary');

  return (
    <>
      <FormSpacer type="pagesection" />
      <FormCard variant="content">
        <StyledDetailedList
          variant="multiple"
          title={field.incomeType}
          list={details}
          titleComponents={
            <IconButton iconProps={{ muiIcon: EditIcon, color: palette.action.active }} onClick={onEdit} />
          }
        />
      </FormCard>
    </>
  );
};

export default IncomePreview;
